export const FEATURE_FLAGS = {
	DATABASE_EXPLORER_RESOURCE_MODAL: 'database-explorer-resource-modal',
	ENABLE_APPROVE_BILLING: 'enable-approve-billing',
	ENABLE_OPTIMIZATION_HUB: 'enable-optimization-hub',
	ENABLE_PARTNER_PORTAL_ORGANIZATIONS_EXPERIMENTAL_COLUMNS: 'enable-partner-portal-organizations-experimental-columns',
	ENABLE_COMMUNITY_PORTAL: 'enable-community-portal',
	ENABLE_CONTAINERS_POD_RECOMMENDATION: 'enable-containers-pod-recommendation',
	ENABLE_CLUSTERS_LIST_TABLE_SORT: 'enable-clusters-list-table-sort',
	SHOW_OPT_HUB_WASTE_WIDGET_NEW_DESIGN: 'show-opt-hub-waste-widget-new-design',
	ENABLE_RECOMMENDATIONS_PAGE: 'enable-recommendations-page',
	ENABLE_CRISIS_POPOVER: 'enable-crisis-modal',
	ENABLE_RI_FEEDBACK_ON_COVERAGE_GRAPH: 'enable-ri-feedback-on-coverage-graph',
	ENABLE_K8S_IN_SIDEBAR: 'enable-k8s-in-sidebar',
	ENABLE_CM_V2_PAGE: 'enable-cm-v2-page',
	ENABLE_K8S_OPTIMIZATION: 'enable-k8s-optimization',
	ENABLE_NEW_USER_PROFILE_MICRO_FRONTEND: 'enable-new-user-profile-micro-frontend',
	ENABLE_NEW_PARTNER_PORTAL: 'enable-new-partner-portal',
	ENABLE_NEW_NOTIFICATION_MANAGEMENT: 'enable-new-notification-management',
	ENABLE_CM_DASHBOARD_V2: 'enable-cm-dashboard-v-2',
	ENABLE_ENABLE_INITIAL_RESOURCES_BFF_ENDPOINT: 'enable-initial-resources-bff-endpoint',
	ENABLE_NEW_ONBOARDING: 'enable-new-onboarding',
	USE_APP_VERSION: 'use-application-version-in-router',
	SHOW_DEPRECATION_BANNER_IN_UNMANAGED_DISKS: 'show-deprecation-banner-in-unmanaged-disks',
};
